// Holiday Campaign Configuration
// Update these values when the official tweet is posted

export const HOLIDAY_CAMPAIGN = {
  // The official tweet that users must reply to
  // Update this when the tweet is posted
  OFFICIAL_TWEET_ID: '2005624907267535281',
  OFFICIAL_TWEET_URL: 'https://x.com/junkfun_/status/2005624907267535281',

  // The secret phrase users must include in their reply
  REQUIRED_MESSAGE: 'Burn the past. Ignite the future.',
};
